export default __webpack_public_path__ + "static/media/back.4fc8df35.svg";